import { render } from "./TrickTablePanel.vue?vue&type=template&id=41a689f0&scoped=true"
import script from "./TrickTablePanel.vue?vue&type=script&lang=js"
export * from "./TrickTablePanel.vue?vue&type=script&lang=js"

import "./TrickTablePanel.vue?vue&type=style&index=0&id=41a689f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a689f0"]])

export default __exports__